import { useEffect, useState } from "react";
import React from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

import Api from "../../Api/Api";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { settingsVideos } from "../../Config/Slider.js";
import { username } from "../../API";

const TrendingHome = () => {
  // const { username } = useParams();
  const [trending, setTrending] = useState([]);
  useEffect(() => {
    const getData = async () => {
      const { show } = await Api.getTrendingTvShows(username);
      setTrending(show);
    };
    getData();
  }, [username]);
  return (
    <div className="container-fluid mt-5">
      {trending.length !== 0 && (
        <>
          <h5 className="text-white fw-normal">Trending</h5>

          <Slider {...settingsVideos} style={{ width: "100%" }}>
            {trending &&
              trending.map((movie, index) => {
                return (
                  <div
                    className="d-inline-flex flex-column p-2"
                    key={index}
                    style={{ maxWidth: "262px" }}
                  >
                    {/* <Link to={`/${username}/tvshowview/${movie._id}`} className="text-decoration-none"> */}
                    <Link
                      to={`/tvshowview/${movie._id}`}
                      className="text-decoration-none"
                    >
                      <div>
                        <img
                          src={`${movie.thumbnail || movie.bannerimage}`}
                          alt={`${movie.title}`}
                          className="rounded"
                          height="125px"
                          width="262px"
                        />
                      </div>
                      <div>
                        <span className="text-light">{`${movie.title} `}</span>
                        <span className="text-light">
                          <small className="text-small">
                            {movie.Languages.length !== 0 &&
                              `(${movie.Languages})`}
                          </small>
                        </span>
                      </div>
                    </Link>
                  </div>
                );
              })}
          </Slider>
        </>
      )}
    </div>
  );
};
export default TrendingHome;
